/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------

==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// papa convert file CSV
import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

// axios
import axios from "axios";
// // Todo: code below use latter
// // auth
// import auth from './auth.js';
// window.auth = auth;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// ACL
import acl from './acl'

// i18n
import i18n from './i18n/i18n.js'

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

//Vee-Validate
import VeeValidate from "vee-validate";
import CustomValidator from '@/validator/custom-validator.js'
Vue.use(CustomValidator)
Vue.use(VeeValidate);

// Vuexy Admin Filters
import filters from "./filters/filters";

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");
// DOMPurify 3.0.6 
import "@/assets/utils/purify.js";
const moment = require('moment')
require('moment/locale/ja')
Vue.use(require('vue-moment'), {
    moment
});
// Vue.prototype.moment = moment

import Cookies from 'js-cookie';

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import {convertMessageError} from "./utils/helpler-utils";

Vue.component("v-select", vSelect);
// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Vue export CSV
import VueJsonToCsv from 'vue-json-to-csv'
Vue.component('VueJsonToCsv', VueJsonToCsv)

Vue.config.productionTip = false;
let loading = true;
// Update config request before call api by axios
axios.interceptors.request.use(
  function(config) {
    let load = config.headers.canLoading;
    if (load) loading = load;
    if (localStorage.noLoading){
        localStorage.removeItem("noLoading");
    } else{
        if (!store.state.loads && loading) {
            store.dispatch("updateLoading", true);
        }
    }
      // console.log('axios.interceptors.request.use')
      // console.log(config)
    if (!config.noToken) {
        // console.log('!config.noToken')
      const token = sessionStorage.getItem("token")
        ? sessionStorage.getItem("token") : Cookies.get('rememberLogin');
      // const tokenPublic = localStorage.getItem('tokenPublic');
      if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      // // code below use latter
      // let usingHash = config.data ? config.data.usingHash : false;
      //
      // if(!usingHash && config.url.includes('upload')) {
      //   try{
      //     usingHash = config.data?config.data.get('usingHash'):false;
      //   }catch(e){
      //
      //   }
      // }
      //
      // if(tokenPublic && usingHash) {
      //   config.headers.Authorization = `Bearer ${tokenPublic}`;
      // }
    }

    config.headers["X-Requested-With"] = "X" + "MLHttpRequest";
    // // code below use latter
    // if(config.data && (!config.url.includes('upload') && !config.url.includes('uploadToCloud')
    //     && !config.data.nowait && !config.nowait)) {
    //   store.dispatch('updateLoading', true);
    // }
    //   console.log('config main.js after')
    //   console.log(config)
    return config;
  },
  function(err) {
    if ((store.state.loading || store.state.loads) && loading) {
      store.dispatch("updateLoading", false);
      store.dispatch("updateLoads", false);
      loading = true;
    }
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  (response) => {
      // process error code
    if (response && response.hasOwnProperty('data')) {
        let result = response.data
        if (result.hasOwnProperty('code')) {
            let code = result.code
            // forbidden
            if (code === 403) {
                // console.log('remove token')
                sessionStorage.removeItem('token')
                Cookies.remove('rememberLogin')
                setTimeout(()=>{
                    window.location.href = 'login'
                },2000)
            }
        }
    }
    if (store.state.loading && !store.state.loads) {
        if (loading) {
          store.dispatch("updateLoading", false);
          loading = true;
        }
        localStorage.removeItem("saveMailDraft");
    }
    return response;
  },
  function(error) {
    if (store.state.loading || store.state.loads) {
      store.dispatch("updateLoading", false)
      store.dispatch("updateLoads", false)
    }
    // Todo: bug 258
    // let messageError = convertMessageError(error.message)
    // return Promise.reject(messageError);
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  i18n,
  acl,
  filters,
  render: (h) => h(App),
}).$mount("#app");
